import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/not-found')({
  component: LeaveNotFound,
})

export function LeaveNotFound() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-slate-50 px-4 py-16 text-slate-900 dark:bg-slate-950 dark:text-slate-50">
      <div className="w-full max-w-4xl rounded-3xl border border-slate-200/80 bg-white/90 p-10 shadow-2xl backdrop-blur dark:border-slate-800 dark:bg-slate-900/70">
        <p className="text-xs font-semibold uppercase tracking-[0.5em] text-slate-500 dark:text-slate-400">
          404 · Leave
        </p>
        <h1 className="mt-6 text-4xl font-semibold leading-tight text-slate-900 dark:text-slate-50">
          That page has gone on leave.
        </h1>
        <p className="mt-4 max-w-2xl text-base text-slate-600 dark:text-slate-300">
          The address you requested does not seem to exist anymore. Use the quick actions below or go back to the dashboard to keep
          moving.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-full border border-slate-900/10 px-5 py-2.5 text-sm font-semibold text-slate-900 transition hover:border-slate-900/40 dark:border-slate-100/10 dark:text-slate-50"
          >
            Back to dashboard
          </Link>
          <Link
            to="/login"
            className="inline-flex items-center justify-center rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-200"
          >
            Sign in
          </Link>
        </div>
        <p className="mt-6 text-sm text-slate-500 dark:text-slate-400">
          Need help? Ask your leave admin to double-check the link or share the steps you took so we can improve the experience.
        </p>
      </div>
    </div>
  )
}
